// extracted by mini-css-extract-plugin
export var background = "L2EGO";
export var backgroundBottomWave = "K+-3C";
export var backgroundDecorator = "g2Xil";
export var backgroundImageDesktop = "_3Yi1n";
export var backgroundImageMobile = "Zcdb8";
export var backgroundImageTablet = "mDk-c";